import { useEffect, useRef } from 'react';
import type { ITransitionProps } from '../../features/routing';
import {
  parsePathname,
  registerViewTransitionCallbacks,
  unregisterViewTransitionCallbacks,
} from '../../features/routing';
import type { IPathInfo } from '../../features/routing/types';

export const useTopBarTransition = (parsedPathname: IPathInfo) => {
  const topBarRef = useRef<HTMLDivElement>(null);

  const currentSectionRef = useRef(parsedPathname.section);

  useEffect(() => {
    currentSectionRef.current = parsedPathname.section;
  }, [parsedPathname]);

  useEffect(() => {
    registerViewTransitionCallbacks('mood-log-top-bar', {
      onBeforeTransition: ({ nextPathname }: ITransitionProps) => {
        const parsedNextPathname = parsePathname(nextPathname);
        const isSameSection = currentSectionRef.current === parsedNextPathname.section;
        if (isSameSection) {
          topBarRef.current?.setAttribute('data-transition', 'stay-put');
        }
      },
      onAfterTransition: () => {
        // Remove the transition direction from the transitionViewport element.
        topBarRef.current?.removeAttribute('data-transition');
      },
    });

    return () => {
      unregisterViewTransitionCallbacks('mood-log-top-bar');
    };
  }, []);

  return {
    topBarRef,
  };
};
